import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: 30,
  },
  navButton: {
    padding: 0,
    fontWeight: 500,
    margin: 0,
    color: theme.palette.common.white,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.common.white,
    },
  },
  toolbar: {
    padding: 0,
  },
  navButtonsWrapper: {
    maxWidth: "1520px",
    margin: "auto",
    width: "95%",
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: 0,
    [theme.breakpoints.up("md")]: {
      width: "90%",
    },
  },
  bundleHover: {
    "& svg": {
      fill: "#fff",
    },
    "&:hover": {
      "& svg": {
        fill: "#fff",
      },
    },
  },
}));
